import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ChargeFastV2Icon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				stroke="transparent"
				d="M12.7846 20.9234C11.8247 20.332 13.0375 17.1897 13.3918 15.053C13.5984 13.807 10.927 14.6191 10.1716 14.3848C8.405 13.837 10.2261 10.741 13.5112 7.30381C16.7968 3.86662 18.4615 2.67674 19.6268 3.07301C20.7916 3.46982 19.4175 7.17953 18.9084 9.82365C18.6561 11.1324 21.5291 10.2205 22.2573 10.5508C23.3251 11.0353 23.251 12.3549 19.0997 16.825C14.9485 21.2951 13.5035 21.366 12.7851 20.9234"
			/>
			<Path
				stroke="transparent"
				d="M9.48321 9.99494H2.8176C2.36628 9.99494 2 9.62865 2 9.17734C2 8.72603 2.36628 8.35974 2.8176 8.35974H9.48321C9.93452 8.35974 10.3008 8.72603 10.3008 9.17734C10.3008 9.62865 9.93452 9.99494 9.48321 9.99494Z"
			/>
			<Path
				stroke="transparent"
				d="M7.6839 13.4768H4.48654C4.03523 13.4768 3.66895 13.1105 3.66895 12.6592C3.66895 12.2078 4.03523 11.8416 4.48654 11.8416H7.6839C8.13522 11.8416 8.5015 12.2078 8.5015 12.6592C8.5015 13.1105 8.13522 13.4768 7.6839 13.4768Z"
			/>
		</>
	),
});
